import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  useTheme
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { i18n } from '../../translate/i18n'
import { messages } from '../../translate/languages'
import { useStyles } from './styles'

const LanguageModal = ({ open, onClose, onSelectLanguage }) => {
  const classes = useStyles()
  const theme = useTheme()

  const handleLanguageSelect = language => {
    onSelectLanguage(language)
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="language-dialog-title"
      maxWidth="xs"
      fullWidth={true}
      scroll="paper"
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle
        id="language-dialog-title"
        onClose={onClose}
        className={classes.title}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {i18n.t('mainDrawer.appBar.user.language')}
          <span className={classes.description}>
            {i18n.t('mainDrawer.appBar.user.description')}
          </span>
        </div>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <List className={classes.list}>
          {Object.keys(messages).map(m => (
            <ListItem
              button
              key={m}
              onClick={() => handleLanguageSelect(m)}
              className={classes.listItem}
              style={
                i18n.language === m
                  ? { backgroundColor: theme.palette.blue_300.main }
                  : undefined
              }
            >
              <ListItemText
                primary={
                  messages[m].translations.mainDrawer.appBar.i18n.language
                }
                secondary={`(${messages[m].translations.mainDrawer.appBar.i18n.language_description})`}
                primaryTypographyProps={
                  i18n.language === m
                    ? { style: { color: theme.palette.white_100.main } }
                    : undefined
                }
                secondaryTypographyProps={
                  i18n.language === m
                    ? { style: { color: theme.palette.white_100.main } }
                    : undefined
                }
                style={{
                  display: 'flex',
                  alignItems: 'baseline',
                  gap: theme.spacing(1)
                }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  )
}

export default LanguageModal
